import { List, Stack, Typography } from "@mui/material";
import { ReactNode, type JSX } from "react";
import { IRecipientUsageDTO } from "../../services/user-role-administration-service/Models";
import RecipientUsageListItem from "./RecipientUsageListItem";

export type RecipientUsageListProps = {
    title: string;
    icon: JSX.Element | ReactNode;
    recipientUsages: Array<IRecipientUsageDTO>;
};

export default function RecipientUsageList({
    title,
    icon,
    recipientUsages
}: RecipientUsageListProps) {
    return recipientUsages.length > 0
        ? (
            <List
                dense
                subheader={
                    <Stack direction="row" sx={{
                        alignItems: "center"
                    }}>
                        {icon}
                        <Typography
                            variant="body2"
                            sx={{
                                fontWeight: "bold",
                                padding: 1
                            }}>
                            {title}
                        </Typography>
                    </Stack>
                }
                sx={{
                    padding: 0
                }}
            >
                {recipientUsages.map(usage =>
                    <RecipientUsageListItem key={usage.id} usage={usage} />
                )}
            </List>
        )
        : (
            <></>
        );
}


